// this factory can be used to store data using the browser's local storage
(function () {
    'use strict';

    angular
        .module('app')
        .factory('storageService', storageService);

    storageService.$inject = ['$localStorage', 'loginService'];

    function storageService($localStorage, loginService) {
        //create empty object to return
        var service = {};
        function initialize() {
            if (!$localStorage.perUserSettings) {
                $localStorage.perUserSettings = {};
            }
            if (!$localStorage.perUserSettings[loginService.id]) {
                $localStorage.perUserSettings[loginService.id] = {};
            }
        }
        
        initialize();

        // add property to object with a getter and a setter. Local storage is used to save information locally. 
        // this data is persistent until the browser's cookies are cleared.
        Object.defineProperty(service, "webApiUrl", {
            get: function () {
                return 'http://localhost/Synergis.WebApi/Api/';
                //return $localStorage.webApiUrl === undefined ? 'http://localhost/Synergis.WebApi' : $localStorage.webApiUrl;
            },
            set: function (webApiUrl) { $localStorage.webApiUrl = webApiUrl; }
        });

        Object.defineProperty(service, "userInfo", {
            get: function () { return $localStorage.userInfo; },
            set: function (userInfo) { $localStorage.userInfo = userInfo; }
        });

        Object.defineProperty(service, "currentTheme", {
            get: function () { return $localStorage.currentTheme; },
            set: function (currentTheme) { $localStorage.currentTheme = currentTheme; }
        });


        Object.defineProperty(service, "columnSetId", {
            get: function () { return $localStorage.columnSetId; },
            set: function (columnSetId) { $localStorage.columnSetId = columnSetId; }
        });

        Object.defineProperty(service, "gridSort", {
            get: function () { return $localStorage.gridSort; },
            set: function (columnSetId) { $localStorage.gridSort = columnSetId; }
        });

        Object.defineProperty(service, "gridState", {
            get: function () { return $localStorage.gridState; },
            set: function (gridState) { $localStorage.gridState = gridState; }
        });

        Object.defineProperty(service, "viewerOptions", {
            get: function () { return $localStorage.viewerOptions; },
            set: function (viewerOptions) { $localStorage.viewerOptions = viewerOptions; }
        });

        Object.defineProperty(service, "viewerUserSettings", {
            get: function () { return $localStorage.viewerUserSettings; },
            set: function (viewerUserSettings) { $localStorage.viewerUserSettings = viewerUserSettings; }
        });

        Object.defineProperty(service, "userSettings", {
            get: function () {
                initialize();
                if ($localStorage.userSettings == undefined) {
                    $localStorage.userSettings = {};                  
                }
                if ($localStorage.userSettings[service.userInfo.id] == undefined) {
                    $localStorage.userSettings[service.userInfo.id] = {};
                }
                return $localStorage.userSettings[service.userInfo.id];
            },
            set: function (userSettings) {
                initialize();
                $localStorage.userSettings[service.userInfo.id] = userSettings;
            }
        });

        Object.defineProperty(service, "lbShowFolder", {
            get: function () {
                initialize();
                if (!$localStorage.perUserSettings[loginService.id].lbShowFolder) {
                    $localStorage.perUserSettings[loginService.id].lbShowFolder = false;
                    return $localStorage.perUserSettings[loginService.id].lbShowFolder;
                }
                else {
                    return $localStorage.perUserSettings[loginService.id].lbShowFolder;
                }
            },
            set: function (value) {
                initialize();
                $localStorage.perUserSettings[loginService.id].lbShowFolder = value;
            }
        });


        Object.defineProperty(service, "qsField", {
            get: function () {
                initialize();
                if (!$localStorage.perUserSettings[loginService.id].qsField) {
                    $localStorage.perUserSettings[loginService.id].qsField = "SCHEMA_S_LONGNAME";
                    return $localStorage.perUserSettings[loginService.id].qsField;
                }
                else {
                    return $localStorage.perUserSettings[loginService.id].qsField;
                }
            },
            set: function (value) {
                initialize();
                $localStorage.perUserSettings[loginService.id].qsField = value;
            }
        });



        return service;
    }
})();